import axios from 'axios'

// const basePath = "http://localhost:9111"; Local development
//const basePath = "https://sulfar.sellina.io/api";
const basePath = "https://sulfur.salescode.ai/api";
const reportBasePath = "https://sellinabundle.s3.ap-south-1.amazonaws.com";


export const get = async (url) => new Promise((res, rej) => {
    axios.get(basePath + url)
        .then(response => {
            const data = response.data;
            res(data)
        })
        .catch(error => {
            console.log(error);
            res(null)
        })
});


export const post = async (url, data) => new Promise((res, rej) => {
    axios.post(basePath + url, data)
        .then(response => {
            res(response.data)
        })
        .catch(error => {
            console.log(error);
            res(null)
        })
});

export const REPORT_BASE_PATH = reportBasePath;
export const API_BASE_PATH = basePath;

